module.exports = __webpack_public_path__ + "images/icon-link.17095605578f7696a702.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icon-link.svg
// module id = Nbn0
// module chunks = 2